"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LiveEventUploadIcon = void 0;
var _core = require("@material-ui/core");
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var LiveEventUploadIcon = function LiveEventUploadIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_core.SvgIcon, _extends({}, props, {
    viewBox: "0 0 24 24"
  }), /*#__PURE__*/_react.default.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("g", {
    "clip-path": "url(#clip0_5552_301869)"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "24",
    height: "24",
    rx: "12",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    width: "24",
    height: "24",
    rx: "12",
    fill: "#13131C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M13.3438 12.6562H15.3438L12 9.34375L8.65625 12.6562H10.6562V15.3438H13.3438V12.6562ZM16.9062 10.6875C17.7604 10.75 18.4896 11.1042 19.0938 11.75C19.6979 12.375 20 13.125 20 14C20 14.9167 19.6667 15.7083 19 16.375C18.3542 17.0208 17.5729 17.3438 16.6562 17.3438H8C6.89583 17.3438 5.94792 16.9583 5.15625 16.1875C4.38542 15.3958 4 14.4479 4 13.3438C4 12.3646 4.34375 11.4896 5.03125 10.7188C5.73958 9.92708 6.58333 9.47917 7.5625 9.375C8 8.5625 8.61458 7.90625 9.40625 7.40625C10.1979 6.90625 11.0625 6.65625 12 6.65625C13.125 6.65625 14.1667 7.05208 15.125 7.84375C16.1042 8.63542 16.6979 9.58333 16.9062 10.6875Z",
    fill: "white"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_5552_301869"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "24",
    height: "24",
    rx: "12",
    fill: "white"
  })))));
};
exports.LiveEventUploadIcon = LiveEventUploadIcon;